/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    class ErrorBlockController {
        constructor() { }
    }

    class ErrorBlockComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/errorBlock/errorBlock.html';
        controller = ErrorBlockController;
        controllerAs = 'err';
        bindings: any = {
            regularErrors: '='
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('errorBlock', new ErrorBlockComponent());
}

